export default __webpack_public_path__ + "static/media/lootex_banner.4df9ef39.jpeg";